/* Copyright Verge Technologies 2018
 * @file contact.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @decription
 */

// Modules
import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import validator from 'validator';
import _ from 'lodash';

// GraphQL
import { CONTACT_US_REQUEST } from '../../graphql';

// Components
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';
import ThankYouModal from '../../components/ThankYouModal/thankyou.modal';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        firstName: '',
        lastName: '',
        companyName: '',
        companyLocation: '',
        email: '',
        contactNumber: '',
        enquiry: '',
        category: '',
      },
      errors: {
        firstNameError: false,
        lastNameError: false,
        companyNameError: false,
        companyLocationError: false,
        emailError: false,
        contactNumberError: false,
        additionalError: false,
      },
      thankYouModalOpen: false,
    };
  }

  handleFormChange = (e) => {
    const updatedForm = { ...this.state.form };
    updatedForm[e.target.name] = e.target.value;
    this.setState({
      ...this.state,
      form: updatedForm,
    });
  };

  checkFields = () => {
    const {
      firstName,
      lastName,
      email,
      contactNumber,
      companyName,
      companyLocation,
      category,
    } = this.state.form;

    // Check that a first name has been entered
    if (firstName === null || _.isUndefined(firstName) || firstName.length < 1) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          firstNameError: true,
        },
      });
      return false;
    } else {
      const { errors } = this.state;
      errors.firstNameError = false;
      this.setState({ errors });
    }

    // Check that a valid last name has been entered
    if (lastName === null || _.isUndefined(lastName) || lastName.length < 1) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          lastNameError: true,
        },
      });
      return false;
    } else {
      const { errors } = this.state;
      errors.lastNameError = false;
      this.setState({ errors });
    }

    // Check that company name passed is valid
    if (companyName === null || _.isUndefined(companyName) || companyName.length < 1) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          companyNameError: true,
        },
      });
      return false;
    } else {
      const { errors } = this.state;
      errors.companyNameError = false;
      this.setState({ errors });
    }

    // Check that company location passed is valid
    if (companyLocation === null || _.isUndefined(companyLocation) || companyLocation.length < 1) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          companyLocationError: true,
        },
      });
      return false;
    } else {
      const { errors } = this.state;
      errors.companyLocationError = false;
      this.setState({ errors });
    }

    // Check for valid email
    if (!validator.isEmail(email)) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          emailError: true,
        },
      });
      return false;
    } else {
      const { errors } = this.state;
      errors.emailError = false;
      this.setState({ errors });
    }

    // Check for valid contactNumber
    if (!validator.isMobilePhone(contactNumber)) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          contactNumberError: true,
        },
      });
      return false;
    } else {
      const { errors } = this.state;
      errors.contactNumberError = false;
      this.setState({ errors });
    }

    // Check that company location passed is valid
    if (category === null || _.isUndefined(category) || category.length < 1) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          categoryError: true,
        },
      });
      return false;
    } else {
      const { errors } = this.state;
      errors.categoryError = false;
      this.setState({ errors });
    }

    return true;
  };

  handleSubmit = (e, mutation) => {
    e.preventDefault();
    if (!this.checkFields()) {
      return;
    }
    mutation();
    this.setState({
      form: {
        firstName: '',
        lastName: '',
        companyName: '',
        companyLocation: '',
        email: '',
        contactNumber: '',
        category: '',
        enquiry: '',
      },
      errors: {
        firstNameError: false,
        lastNameError: false,
        companyNameError: false,
        companyLocationError: false,
        emailError: false,
        contactNumberError: false,
        categoryError: false,
      },
      thankYouModalOpen: true,
    });
  };

  render() {
    return (
      <div>
        <Header crumbs={this.props.crumbs} />
        <ThankYouModal
          isOpen={this.state.thankYouModalOpen}
          closeModal={() => {
            this.setState({ ...this.state, thankYouModalOpen: false });
          }}
        />
        <div className="page-heading heading-contact">Contact us</div>
        <div className="heading-container">
          <h1>Please complete the form below</h1>
          <hr />
        </div>
        <div className="contact-container">
          <Mutation
            mutation={CONTACT_US_REQUEST}
            variables={{
              params: this.state.form,
            }}
          >
            {(postMutation) => {
              return (
                <div className="form-block">
                  <div className="form">
                    <form name="">
                      <div className="row">
                        <input
                          type="text"
                          name="firstName"
                          placeholder="First name"
                          value={this.state.form.firstName}
                          onChange={e => this.handleFormChange(e)}
                        />
                        {
                          this.state.errors.firstNameError ? <label className="error">Please enter yout name</label> : ''
                        }
                      </div>
                      <div className="row">
                        <input
                          type="text"
                          name="lastName"
                          placeholder="Last name"
                          value={this.state.form.lastName}
                          onChange={e => this.handleFormChange(e)}
                        />
                        {
                          this.state.errors.lastNameError ? <label className="error">Please enter your last name</label> : ''
                        }
                      </div>
                      <div className="row">
                        <input
                          type="text"
                          name="companyName"
                          placeholder="Company name"
                          value={this.state.form.companyName}
                          onChange={e => this.handleFormChange(e)}
                        />
                        {
                          this.state.errors.companyNameError ? <label className="error">Please add a valid company name</label> : ''
                        }
                      </div>
                      <div className="row">
                        <input
                          type="text"
                          name="companyLocation"
                          placeholder="Company location"
                          value={this.state.form.companyLocation}
                          onChange={e => this.handleFormChange(e)}
                        />
                        {
                          this.state.errors.companyLocationError ? <label className="error">Please add a valid company location</label> : ''
                        }
                      </div>
                      <div className="row">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email address"
                          value={this.state.form.email}
                          onChange={e => this.handleFormChange(e)}
                        />
                        {
                          this.state.errors.emailError ? <label className="error">Please add a valid company email</label> : ''
                        }
                      </div>
                      <div className="row">
                        <input
                          type="text"
                          name="contactNumber"
                          placeholder="Contact number"
                          value={this.state.form.contactNumber}
                          onChange={e => this.handleFormChange(e)}
                        />
                        {
                          this.state.errors.contactNumberError ? <label className="error">Please add a valid contact number</label> : ''
                        }
                      </div>
                      <div className="row">
                        <div className="select">
                          <select
                            name="category"
                            value={this.state.form.category}
                            onChange={e => this.handleFormChange(e)}
                          >
                            <option value="">What do you require?</option>
                            <option value="Resale">Is this for resale purposes?</option>
                            <option value="General">General</option>
                          </select>
                        </div>
                        {
                          this.state.errors.categoryError ? <label className="error">Please select a category</label> : ''
                        }
                      </div>
                      <div className="row">
                        <textarea
                          name="enquiry"
                          placeholder="Additional query.."
                          value={this.state.form.enquiry}
                          onChange={e => this.handleFormChange(e)}
                        />
                      </div>
                      <div className="control">
                        <a onClick={e => this.handleSubmit(e, postMutation)} className="button button-green">
                          Submit
                        </a>
                      </div>
                    </form>
                  </div>
                </div>
              );
            }}
          </Mutation>
          <div className="details-block">
            <h4>Contact details</h4>
            <p>
              Switchboard:
              <br />
              +27 11 919 1000
            </p>
            <p>
              Cape Town:
              <br />
              +27 21 557 9480
            </p>
            <p>
              Fax:
              <br />
              +27 86 585 4676
            </p>
            <p>
              Email:
              <br />
              <a href="mailto:info@separations.co.za">info@separations.co.za</a>
            </p>
            <h4>Social media</h4>
            <p>
              <div className="icon">
                <svg width="8px" height="15px" viewBox="0 0 8 15">
                  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="social-fb" transform="translate(0.000000, -1.000000)" fill="#004DA9">
                      <path
                        d="M5.082,16 L5.082,9.164 L7.415,9.164 L7.748,6.5 L5.082,6.5 L5.082,4.832 C5.082,4.082 5.332,3.499 6.415,3.499 L7.831,3.499 L7.831,1.083 C7.5,1.083 6.665,1 5.748,1 C4.80931197,0.93763403 3.89038283,1.28940982 3.23329482,1.96265574 C2.5762068,2.63590166 2.24685365,3.56310362 2.332,4.5 L2.332,6.5 L0,6.5 L0,9.164 L2.333,9.164 L2.333,16 L5.082,16 Z"
                        id="Facebook"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://www.facebook.com/separations"
              >
                Facebook
              </a>
            </p>
            <p>
              <div className="icon">
                <svg width="16px" height="13px" viewBox="0 0 16 13">
                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(0.000000, -1.000000)" fill="#004DA9">
                      <path
                        d="M4.834,13.382 C7.20256415,13.4035681 9.48039314,12.4721876 11.1552903,10.7972903 C12.8301876,9.12239314 13.7615681,6.84456415 13.74,4.476 L13.74,4.052 C14.3326764,3.60100575 14.8483592,3.05695538 15.267,2.441 C14.6983386,2.68835635 14.0994912,2.85950364 13.486,2.95 C14.1174599,2.55297973 14.5957916,1.95374338 14.843,1.25 C14.230039,1.59112706 13.5737576,1.84778656 12.892,2.013 C12.3102233,1.35995 11.4745638,0.990247231 10.6,0.999 C8.87793315,1.02527929 7.48827929,2.41493315 7.462,4.137 C7.44269189,4.36678396 7.47164478,4.59806638 7.547,4.816 C5.0215997,4.69431458 2.67161805,3.48852284 1.1,1.508 C0.821017676,1.99900795 0.674877646,2.55427114 0.676,3.119 C0.699322278,4.15853134 1.20120727,5.12908836 2.036,5.749 C1.52612022,5.73880652 1.02824766,5.59241403 0.594,5.325 C0.59241996,6.82386153 1.66344237,8.10917262 3.138,8.378 C2.86188325,8.45251427 2.57541294,8.48122887 2.29,8.463 C2.08823133,8.47660221 1.8858565,8.44764285 1.696,8.378 C2.12106627,9.66598279 3.30913169,10.5483284 4.665,10.583 C3.55064064,11.4538145 2.17922542,11.9309966 0.765,11.94 C0.507060426,11.9539404 0.248588271,11.9252213 0,11.855 C1.40338894,12.8741833 3.09980052,13.4100585 4.834,13.382"
                        id="Twitter"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://www.twitter.com/separations001"
              >
                Twitter
              </a>
            </p>
            <p>
              <div className="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                  <path fill="#004DA9" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/company/separations"
              >
                Linkedin
              </a>
            </p>
            <p>
              <div className="icon">
                <svg width="16px" height="12px" viewBox="0 0 16 12">
                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-1.000000, 0.000000)" fill="#004DA9" fillRule="nonzero">
                      <path
                        d="M16.56,2.594 C16.6199353,1.28317068 15.6067551,0.171536581 14.296,0.11 C12.606,0.031 10.873,0 9.106,0 L8.557,0 C6.795,0 5.063,0.031 3.368,0.11 C2.05685682,0.175259473 1.0454319,1.28863173 1.106,2.6 C1.03,3.689 0.996,4.778 0.999,5.867 C1.002,6.956 1.03,8.045 1.099,9.138 C1.03839099,10.4495405 2.04879014,11.5636161 3.36,11.631 C5.141,11.714 6.967,11.75 8.824,11.747 C10.681,11.744 12.504,11.716 14.288,11.631 C15.6001483,11.5646714 16.6120186,10.4504521 16.552,9.138 C16.625,8.046 16.659,6.957 16.652,5.864 C16.645,4.771 16.634,3.687 16.56,2.594 Z M7.333,8.869 L7.333,2.857 L11.769,5.857 L7.333,8.869 Z"
                        id="You_Tube"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://www.youtube.com/user/SeparationsChannel/"
              >
                Youtube
              </a>
            </p>
          </div>
        </div>

        <div className="heading-container">
          <h1>Offices</h1>
          <hr />
        </div>

        <div className="content-list-container popular-list">
          <ul>
            <li>
              <div className="contact-block">
                <div className="icon">
                  <svg width="64px" height="64px" viewBox="0 0 64 64">
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <g transform="translate(1.000000, 1.000000)" stroke="#004DA9" strokeWidth="3">
                        <rect
                          id="Rectangle_1260"
                          x="0.5"
                          y="0.502"
                          width="38.728"
                          height="60.583"
                        />
                        <rect
                          id="Rectangle_1261"
                          x="39.228"
                          y="30.829"
                          width="22.212"
                          height="30.327"
                        />
                        <path d="M0.5,54.502 L39.228,54.502" id="Line_54" />
                        <rect
                          id="Rectangle_1262"
                          x="6.337"
                          y="8.547"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1263"
                          x="17.088"
                          y="8.547"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1264"
                          x="27.837"
                          y="8.547"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1265"
                          x="6.337"
                          y="19.225"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1266"
                          x="17.088"
                          y="19.225"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1267"
                          x="27.837"
                          y="19.225"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1268"
                          x="6.337"
                          y="29.975"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1269"
                          x="17.088"
                          y="29.975"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1270"
                          x="47.272"
                          y="37.023"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1271"
                          x="47.272"
                          y="47.702"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1272"
                          x="27.837"
                          y="29.975"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1273"
                          x="14.027"
                          y="43.644"
                          width="11.675"
                          height="11.675"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="heading">Head Office</div>
                <hr />
                <div className="address">
                  9 Will Scarlet Road
                  <br />
                  Robindale
                  <br />
                  Randburg
                  <br />
                  2194
                </div>
              </div>
              <div className="map-block">
                <iframe
                  title="map"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3582.604267756689!2d27.9961179!3d-26.1118337!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9574b77454f32d%3A0xcba7003d6f1ee295!2sSeparations!5e0!3m2!1sen!2sza!4v1536824403476"
                  width="100%"
                  height="270"
                  frameBorder="0"
                  style={{ border: '0' }}
                  allowFullScreen
                />
              </div>
            </li>
            <li>
              <div className="contact-block">
                <div className="icon">
                  <svg width="64px" height="64px" viewBox="0 0 64 64">
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <g transform="translate(1.000000, 1.000000)" stroke="#004DA9" strokeWidth="3">
                        <rect
                          id="Rectangle_1260"
                          x="0.5"
                          y="0.502"
                          width="38.728"
                          height="60.583"
                        />
                        <rect
                          id="Rectangle_1261"
                          x="39.228"
                          y="30.829"
                          width="22.212"
                          height="30.327"
                        />
                        <path d="M0.5,54.502 L39.228,54.502" id="Line_54" />
                        <rect
                          id="Rectangle_1262"
                          x="6.337"
                          y="8.547"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1263"
                          x="17.088"
                          y="8.547"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1264"
                          x="27.837"
                          y="8.547"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1265"
                          x="6.337"
                          y="19.225"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1266"
                          x="17.088"
                          y="19.225"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1267"
                          x="27.837"
                          y="19.225"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1268"
                          x="6.337"
                          y="29.975"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1269"
                          x="17.088"
                          y="29.975"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1270"
                          x="47.272"
                          y="37.023"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1271"
                          x="47.272"
                          y="47.702"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1272"
                          x="27.837"
                          y="29.975"
                          width="6.122"
                          height="6.122"
                        />
                        <rect
                          id="Rectangle_1273"
                          x="14.027"
                          y="43.644"
                          width="11.675"
                          height="11.675"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="heading">Cape Town Branch</div>
                <hr />
                <div className="address">
                  112 Edward Road
                  <br />
                  Bloemhof Building
                  <br />
                  Bellville
                  <br />
                  7550
                </div>
              </div>
              <div className="map-block">
                <iframe
                  title="map-2"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d723.39702089149!2d18.63535622663774!3d-33.88037316204189!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5aba67dcfbeea32b!2sBloemhof+Building+-+Pinnacle!5e0!3m2!1sen!2sza!4v1536579157876"
                  width="100%"
                  height="270"
                  frameBorder="0"
                  style={{ border: '0' }}
                  allowFullScreen
                />
              </div>
            </li>
          </ul>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact/contact.page.js